import { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { useMount } from "react-use";
import { LivechatSubjectType } from "@scrile/api-provider/dist/api/LivechatsProvider";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import { Conference } from "@scrile/api-provider/dist/projects/webvideo/ConferenceProvider";
import providers from "../../lib/providers";
import { Routes } from "../../router/config";

interface Props {
  conferenceUuid: string;
}

export default function useController({ conferenceUuid }: Props) {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [conference, setConference] = useState<Conference | null>(null);

  const onClose = () => history.push(Routes.root);
  const livechatSubject: Subject<LivechatSubjectType> | null = conference
    ? {
        subjectId: conference.id,
        subjectType: LivechatSubjectType.CONFERENCE,
      }
    : null;

  const ownerId = useMemo(() => conference?.ownerId ?? "0", [conference]);

  const getConferenceData = async () => {
    try {
      setLoading(true);
      const response = await providers.ConferenceProvider.search({ uuids: [conferenceUuid] });
      if (!response.result.length) {
        onClose();
      }
      setConference(response.result[0]);
    } finally {
      setLoading(false);
    }
  };
  useMount(() => getConferenceData());

  return {
    history,
    livechatSubject,
    loading,
    ownerId,
    onClose,
  };
}
